var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "train-form" },
    [
      _c(
        "div",
        {
          attrs: {
            "text-type": "h6",
            "text-bottom": "2",
            "text-color": "default",
          },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.selectStory")))]
      ),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticClass: "select-block",
          attrs: { value: _vm.selectedStoryId },
          on: {
            change: function (e) {
              return (_vm.selectedStoryId = e)
            },
          },
        },
        _vm._l(_vm.allStories, function (story) {
          return _c(
            "a-select-option",
            { key: story._id, attrs: { value: story._id } },
            [
              _c("span", { staticClass: "blockTypeText" }, [
                _vm._v(_vm._s(story.title)),
              ]),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt-2",
          attrs: {
            "text-type": "h6",
            "text-bottom": "2",
            "text-color": "default",
          },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.selectBlock")))]
      ),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticClass: "select-block",
          attrs: {
            value: _vm.selectedBlockId,
            showSearch: "",
            placeholder: _vm.$t("chatbotv2.selectBlock"),
            notFoundContent: _vm.$t("chatbotv2.noBlocksFound"),
            size: "large",
            "filter-option": false,
          },
          on: {
            change: _vm.handleSelectBlockChange,
            search: _vm.handleSelectBlockSearch,
            select: _vm.handleSelectBlockSelect,
          },
        },
        _vm._l(_vm.getInputBlocks(), function (block) {
          return _c(
            "a-select-option",
            { key: block.id, attrs: { value: block.id } },
            [
              _c(
                "div",
                { staticClass: "block-row" },
                [
                  _c("BlockIconPreview", {
                    staticClass: "img",
                    attrs: { "block-type": block.type },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "blockTypeText" }, [
                    _vm._v(
                      _vm._s(block.name || _vm.$t("chatbotv2." + block.type))
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "train-phrases-buttons" },
        [
          _c("a-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("message.cancel"))),
          ]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "ml-3",
              attrs: {
                type: "primary",
                disabled: !_vm.selectedStoryId || !_vm.selectedBlockId,
              },
              on: {
                click: function () {
                  return _vm.onTrain(
                    _vm.selectedStoryId,
                    _vm.storyVersion,
                    _vm.selectedBlockId
                  )
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.train")) + "\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }